var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DashboardTemplate',[(_vm.getRule === 'admin' || _vm.getRule === 'exclusiveboard' || _vm.getRule === 'staff')?_c('ActiveActivitiesNav',{attrs:{"nav":{
        dashboard:false,
        activity:false,
        milestone:false,
        document:true
      }}}):_vm._e(),_c('DocumentActivities')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }